<div class="route-logo-spinner" role="status" aria-label="Loading">
  <img
    [src]="'assets/animated-logo-white-outline-blue-shimmer-v2.svg'"
    [attr.width]="width"
    [attr.height]="height"
    alt="Loading"
    class="spinner-logo"
  />
  <span class="visually-hidden">Loading...</span>
</div>
